import { EyeOutlined } from '@ant-design/icons'
import { Checkbox, Collapse, Space, Tag, Typography } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import type { LayerKey, LayerVisibility } from '../types'

const groups: { title: string; phase: 'P0' | 'P1'; items: [LayerKey, string, string][] }[] = [
  {
    title: '空间基础',
    phase: 'P0',
    items: [
      ['map', '地图', '#7894a8'],
      ['history', '历史轨迹', '#6f8198'],
      ['globalPath', '全局路径', '#5bbdff'],
      ['localPlanned', '局部计划', '#ffc14f'],
      ['localExecuted', '局部执行', '#52d6ad'],
      ['peerRobots', '协同机器人', '#ff77c8'],
    ],
  },
  {
    title: '量测传感器',
    phase: 'P0',
    items: [
      ['laser', '激光', '#64e7da'],
      ['infrared', '红外', '#ff7575'],
      ['sonar', '超声波', '#ad7dff'],
    ],
  },
  {
    title: '专家诊断',
    phase: 'P1',
    items: [
      ['localGrid', '局部地图', '#4ad8ca'],
      ['costGrid', '代价地图', '#ff9a42'],
      ['motionGrid', '运动地图', '#b16fff'],
      ['strategies', '定位策略', '#6fa6ff'],
      ['trajectories', 'DWA 候选', '#ffd658'],
    ],
  },
]

export function LayerPanel({ value, onChange }: { value: LayerVisibility; onChange: (value: LayerVisibility) => void }) {
  const change = (key: LayerKey) => (event: CheckboxChangeEvent) => onChange({ ...value, [key]: event.target.checked })
  return (
    <div className="layer-panel">
      <div className="panel-title">
        <Space>
          <EyeOutlined />
          <Typography.Text strong>图层</Typography.Text>
        </Space>
        <Typography.Text type="secondary">2D</Typography.Text>
      </div>
      <Collapse
        ghost
        defaultActiveKey={groups.map((group) => group.title)}
        items={groups.map((group) => ({
          key: group.title,
          label: (
            <Space>
              <span>{group.title}</span>
              <Tag variant="filled" color={group.phase === 'P0' ? 'blue' : 'purple'}>
                {group.phase}
              </Tag>
            </Space>
          ),
          children: (
            <div className="layer-options">
              {group.items.map(([key, label, color]) => (
                <Checkbox key={key} checked={value[key]} onChange={change(key)}>
                  <span className="layer-swatch" style={{ background: color }} />
                  {label}
                </Checkbox>
              ))}
            </div>
          ),
        }))}
      />
    </div>
  )
}
